import React, {useContext, useEffect, useRef, useState} from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import _axios from "../../../httpService";
import Loader from "../../Loader";
import { toast } from "react-toastify";
import {SetPrintDataContext} from "../../../Pages";

const LevelForm = () => {
  const [indexFieldShow, setIndexFieldShow] = useState(-1); // 0=loading   -1= nothing    1==data
  const [indexFieldData, setIndexFieldData] = useState([]);
  const [accountCode, setAccountCode] = useState({});
  const [mode, setMode] = useState("");
  const [accountList, setAccountList] = useState([]);
  const location = useLocation();
  const setNeedToReloadSidebar = useContext(SetPrintDataContext);

  useEffect(() => {
    setIndexFieldShow(-1);
    formRef.current.reset();
    setMode(location.state.mode);
  }, [location.state.mode]);

  // const state = location.state;
  // console.log(state);

  function typeAccountHandler() {
    setIndexFieldShow(0);
    setAccountCode("");
    let selectValue = typeAccountRef.current.value;
    if (selectValue === "1" && mode === "add") {
      setIndexFieldShow(-1);
      setIndexFieldData([]);
    } else {
      setIndexFieldShow(0);
      let path =
        mode === "add"
          ? `${localStorage.getItem("apiUrl2")}w/upl/`
          : `${localStorage.getItem("apiUrl2")}w/cld/`;

      axios({
        method: "GET",
        url: path,
        params: {
          level: selectValue,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }).then((response) => {
        setIndexFieldShow(1);
        mode === "edit"
          ? setAccountList(response.data)
          : setIndexFieldData(response.data);
      });
    }
  }

  const getAcountantCodeHandler = (e) => {
    let value = e.target.value;
    let selectValue = typeAccountRef.current.value;
    console.log(location.state.mode);
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl2")}w/ngc/`,
      params: {
        level: selectValue,
        key: value,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      //   accountCodeRef.current.value = response.data.code;
      setAccountCode(response.data);
    });
  };
  const getEditDataHandler = (e) => {
    let value = e.target.value;

    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl2")}/w/lds/`,
      params: {
        key: value,
      },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      //   accountCodeRef.current.value = response.data.code;
      setAccountCode(response.data);
      setStatus(response.data.status);
    });
  };
  const [status, setStatus] = useState("active");
  function statusChangeHandler(e) {
    setStatus(e.target.value);
  }
  const typeAccountRef = useRef(null);
  const indexAccountRef = useRef(null);
  const accountCodeRef = useRef(null);
  const accountTitleRef = useRef(null);
  const accountRef = useRef(null);
  const formRef = useRef(null);

  function submitHandler(e) {
    e.preventDefault();
    if (typeAccountRef.current.value === "nullSelect") {
      toast.error("لطفا نوع حساب را انتخاب کنید.");
      return;
    } else {
      if (
        typeAccountRef.current.value !== "1" &&
        indexAccountRef.current !== null
      ) {
        if (indexAccountRef.current.value === "nullSelect") {
          toast.error("لطفاحساب سرشاخه را انتخاب کنید.");
          return;
        }
      }
    }
    // این که از بک میاد میشینه. ینی باید با ریکوئستی که میزنم بشونم. متناسب با نوع شاخص که باید بعدا بنویسم

    if (accountTitleRef.current.value === "") {
      toast.error("لطفا فیلد عنوان حساب را پر کنید.");
      return;
    }
    if (status === "") {
      toast.error("لطفا وضعیت را انتخاب کنید.");
      return;
    }

    let data = {
      level: typeAccountRef.current.value,

      key:
        mode === "add"
          ? indexAccountRef.current
            ? indexAccountRef.current.value
            : ""
          : accountRef.current.value,
      // code: accountCodeRef.current.value,
      name: accountTitleRef.current.value,
      status: status,
    };
    let path = "";
    path = mode === "add" ? "x/ade/" : "y/eld/";
    _axios.post(`${localStorage.getItem("apiUrl2")}`+path, data).then((response) => {
      setNeedToReloadSidebar(response.data)
      toast.success(response.data.message);
    });
  }

  return (
    <>
      <form className="formChanges" ref={formRef}>
        <div className="title-template">
          <div className="line"></div>
          <div className="lable-box-title-new">
            <label className="headLabel">فرم سطح</label>
          </div>
        </div>
        {/*  نوع حساب و فیلد شاخص*/}
        <div className="selectBox">
          <div className="selectBox-sides">
            <label htmlFor="accountType" className="control-lable form-label">
              نوع حساب
            </label>
            <select
              ref={typeAccountRef}
              defaultValue={"nullSelect"}
              className="inputBox"
              id="accountType"
              onChange={typeAccountHandler}
            >
              <option value={"nullSelect"} hidden={true}>
                گزینه مورد نظر خود را انتخاب کنید
              </option>
              <option value="1">گروه</option>
              <option value="2">کل</option>
              <option value="3">معین</option>
            </select>
          </div>
          {/* فیلد شاخص متناسب با شرایط بیاد و نیاد */}
          {mode === "add" ? (
            indexFieldShow === 0 ? (
              <Loader />
            ) : indexFieldShow === -1 ? (
              <></>
            ) : (
              <div className="selectBox-sides">
                <label
                  htmlFor="topLevelAccount"
                  className="control-lable form-label"
                >
                  حساب سرشاخه
                </label>
                <select
                  ref={indexAccountRef}
                  className="inputBox"
                  id="topLevelAccount"
                  onChange={getAcountantCodeHandler}
                  defaultValue="nullSelect"
                >
                  <option value={"nullSelect"} hidden={true}>
                    گزینه مورد نظر خود را انتخاب کنید
                  </option>
                  {indexFieldData.map((v) => (
                    <option value={v.key} key={v.key}>
                      {v.name}
                    </option>
                  ))}
                </select>
              </div>
            )
          ) : (
            <div className="selectBox-sides">
              <label
                htmlFor="topLevelAccount"
                className="control-lable form-label"
              >
                لیست حساب ها
              </label>
              <select
                className="inputBox"
                id="topLevelAccount"
                defaultValue="nullSelect"
                onChange={getEditDataHandler}
                ref={accountRef}
              >
                <option value={"nullSelect"} hidden={true}>
                  گزینه مورد نظر خود را انتخاب کنید
                </option>
                {accountList.map((v) => (
                  <option value={v.key} key={v.key}>
                    {v.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        {/* کد حساب */}
        <div className="selectWidthComplete">
          <label htmlFor="InputName" className="control-lable form-label">
            کد حساب
          </label>
          <input
            ref={accountCodeRef}
            type="text"
            className="form-control inputBox"
            id=""
            name=""
            disabled
            autoComplete="off"
            placeholder=" کد حساب "
            required
            defaultValue={accountCode.code}
          />
          <label className="error-msg"></label>
        </div>
        {/* عنوان حساب یک و دو */}
        <div className="selectBox">
          <div className="selectBox-sides">
            <label htmlFor="InputName" className="control-lable form-label">
              عنوان حساب
              <sup>[1]</sup>
            </label>
            <input
              ref={accountTitleRef}
              type="text"
              className="form-control inputBox"
              id=""
              name=""
              defaultValue={mode === "edit" ? accountCode.name : ""}
              autoComplete="off"
              maxLength="11"
              placeholder="متن مورد نظر خود را وارد کنید"
              required=""
            />
            <label className="error-msg"></label>
          </div>
        </div>

        {/* وضعیت */}
        <div className="selectBox-sides">
          <div className="CheckBOX mb-2">
            <label htmlFor="InputName" className="control-lable form-label">
              وضعیت:
            </label>
            <input
              onClick={statusChangeHandler}
              type="radio"
              className="form-check-input"
              id="000"
              name="statuschoose"
              defaultChecked={status === "active"}
              value="active"
            />
            <label className="" htmlFor="statusCheckBox">
              فعال
            </label>
            <input
              onClick={statusChangeHandler}
              type="radio"
              className="form-check-input"
              id="000"
              defaultChecked={status === "deactive"}
              name="statuschoose"
              value="deactive"
            />
            <label className="" htmlFor="statusCheckBox">
              غیر فعال
            </label>
          </div>
        </div>

        {/**/}
        <div className="button-box mx-auto my-3 twoBtn ">
          <button
            type="submit"
            className=" btn-confirm"
            onClick={submitHandler}
          >
            ثبت
          </button>
        </div>
      </form>
    </>
  );
};

export default LevelForm;
